<template>
  <tr>
    <td class="text-center" >
      {{ propertyCosting.minLot }}
    </td>
    <td class="text-center">
      {{ propertyCosting.maxLot }}
    </td>
    <td class="text-center">
      ${{ propertyCosting.amount }}
    </td>
    <td class="text-center">
      {{ propertyCosting.isAmtPerLot? 'Yes' : 'No' }}
    </td>
    <td class="button-2 text-center">
      <button class="btn btn-indigo" @click="editPropertyCosting()">
        <i class="fa fa-edit"></i> Edit
      </button>
      <button class="my-3 btn btn-danger" @click="deleteProprtyCosting()">
        <i class="fa fa-trash" /> Delete
      </button>
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'PropertyCostingRow',
    props: {
      object: {
        type: Object
      }
    },
    computed: {
      propertyCosting () {
        return {
          ...this.object
        }
      }
    },
    methods: {
      editPropertyCosting () {
        this.$emit('edit', { permalink: 'editPropertyCosting', uuid: this.propertyCosting.uuid })
      },
      deleteProprtyCosting () {
        this.$emit('deleteObject', { permalink: 'deletePropertyCosting', uuid: this.propertyCosting.uuid })
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/rows/PropertyCosting.vue